import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { createClientMatch, updateClientProfile, getPaidCandidates } from "../apiService";
import "./MatchesPage.css";

const MatchesPage = () => {
  const [profiles, setProfiles] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // 1. Load profiles from localStorage
    const menData = localStorage.getItem("menToShow");
    if (!menData) {
      navigate("/done");
      return;
    }
    const parsed = JSON.parse(menData);
    setProfiles(parsed);

    // 2. Load the saved currentIndex from localStorage
    const savedIndex = parseInt(localStorage.getItem("currentIndex") || "0", 10);
    // Ensure it's within bounds
    const validIndex = Math.min(savedIndex, parsed.length - 1);
    setCurrentIndex(validIndex);
  }, [navigate]);

  // const handleSwipe = async (candidateId, groupId) => {
  //   if (buttonDisabled) return;
  //   setButtonDisabled(true);
  //   try {
  //     const womanId = localStorage.getItem("womanId");

  //     // Create the match with the specified groupId
  //     await createClientMatch(womanId, candidateId, groupId);

  //     // Update swipe count
  //     let swipeCount = parseInt(localStorage.getItem("swipeCount"), 10) || 0;
  //     swipeCount += 1;

  //     const formData = new FormData();
  //     formData.append("prof_225", swipeCount.toString());
  //     await updateClientProfile(womanId, formData);

  //     localStorage.setItem("swipeCount", swipeCount.toString());

  //     // Move to next candidate or fetch more if needed
  //     if (currentIndex < profiles.length - 1) {
  //       const newIndex = currentIndex + 1;
  //       setCurrentIndex(newIndex);
  //       localStorage.setItem("currentIndex", newIndex.toString());
  //     } else {
  //       // Fetch more candidates instead of navigating to /done
  //       const needed = 10;
  //       const data = await getPaidCandidates(womanId, needed);
  //       if (data.objects && data.objects.length > 0) {
  //         setProfiles(data.objects);
  //         setCurrentIndex(0);
  //         localStorage.setItem("menToShow", JSON.stringify(data.objects));
  //         localStorage.setItem("currentIndex", "0");
  //       } else {
  //         navigate("/done");
  //       }
  //     }

  //     // Scroll to top after swipe
  //     window.scrollTo({ top: 0, behavior: "smooth" });
  //   } catch (err) {
  //     console.error("Error handling swipe:", err);
  //     //navigate("/done");
  //   } finally {
  //     setButtonDisabled(false);
  //   }
  // };

  const handleSwipe = async (candidateId, groupId) => {
    if (buttonDisabled) return;
    setButtonDisabled(true);

    const womanId = localStorage.getItem("womanId");
    console.log("🔑 Using womanId:", womanId, "| candidateId:", candidateId, "| groupId:", groupId);

    if (!womanId) {
      console.error("❌ No womanId in localStorage — sending back to login");
      navigate("/");
      return;
    }

    try {
      await createClientMatch(womanId, candidateId, groupId);

      // Update swipe count locally and in SmartMatch
      let swipeCount = parseInt(localStorage.getItem("swipeCount"), 10) || 0;
      swipeCount += 1;
      localStorage.setItem("swipeCount", swipeCount.toString());

      updateClientProfile(womanId, {
        prof_225: swipeCount.toString(),
        prof_227: new Date().toISOString().split("T")[0],
      }).catch(err => console.error("Non-fatal: failed to update swipe count:", err));

      // Advance to next card or fetch more
      if (currentIndex < profiles.length - 1) {
        const newIndex = currentIndex + 1;
        setCurrentIndex(newIndex);
        localStorage.setItem("currentIndex", newIndex.toString());
      } else {
        const data = await getPaidCandidates(womanId, 10);
        if (data.objects && data.objects.length > 0) {
          setProfiles(data.objects);
          setCurrentIndex(0);
          localStorage.setItem("menToShow", JSON.stringify(data.objects));
          localStorage.setItem("currentIndex", "0");
        } else {
          navigate("/done");
        }
      }

      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (err) {
      console.error("Error handling swipe:", err);
    } finally {
      setButtonDisabled(false);
    }
  };

  if (profiles.length === 0) {
    return <div className="matches-page">Loading...</div>;
  }

  // Safeguard: if currentIndex goes beyond the array, fetch more or go to "done"
  if (currentIndex >= profiles.length) {
    navigate("/done");
    return null;
  }

  const currentProfile = profiles[currentIndex];

  return (
    <div className="matches-page">
      <div className="profile-top-section">
        <img src="/logos/bond_logo_white.png" alt="Bond Logo" className="bond-logo-match" />
        <img
          src={currentProfile.coverUrl || "/avatars/default.png"}
          alt={currentProfile.name}
          className="profile-photo"
        />
        <h3 className="premier-member">Premier Member | {currentProfile.name}</h3>
        <h4 className="profile-title">{currentProfile.occupation}</h4>
      </div>
      <div className="profile-description-section">
        <div className="profile-description-container">
          <p className="profile-description">
            {currentProfile.presentationBio || "No bio available."}
          </p>
        </div>
        <div className="match-question-container">
          <p className="match-question">
            Would you like to be considered for a match with {currentProfile.name}?
          </p>
        </div>
        <div className="response-buttons">
          <button onClick={() => handleSwipe(currentProfile.clientId, 42)} disabled={buttonDisabled}>
            No
          </button>
          <button onClick={() => handleSwipe(currentProfile.clientId, 44)} disabled={buttonDisabled}>
            I'm Open
          </button>
          <button onClick={() => handleSwipe(currentProfile.clientId, 41)} disabled={buttonDisabled}>
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default MatchesPage;